<script>
export default {
    data() {
        return {
            menuOpen: false
        }
    },
    props: {
        items: Array,
        themeDir: String,
        title: String,
        id: String
    },
    methods: {
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
        }
    }
}
</script>

<style scoped>
    .link-stack-dropdown-menu {
        display: none;
    }

    .link-stack-dropdown:focus-within .link-stack-dropdown-menu {
        display: flex;
    }
</style>

<template>
    <div class='link-stack-dropdown relative max-w-xl w-full mx-auto'>
        <button class="flex justify-between items-center p-3 w-full border" @click="toggleMenu" :aria-controls="`#${id}`">
            <span class='pr-4'>{{ (title != '' ? title : 'Quick select') }}</span>
            <img :src="`${themeDir}/images/expand_more_black_24dp.svg`" alt="Expand icon">
        </button>
        <ul class='link-stack-dropdown-menu bg-sky-50 p-6 flex-col gap-3 absolute shadow-2xl w-full z-10' :id="id" :aria-expanded="menuOpen">
            <li v-for="item in items">
                <a :href="item.LinkURL" class="text-current" :target="item.OpenInNewWindow === 1 ? '_blank' : '_self'" :title="`Go to ${item.Title} page`">{{item.Title}}</a>
            </li>
        </ul>
    </div>
</template>
